<svg:rect width="100%" height="100%" fill="transparent"></svg:rect>
<svg:rect class="line" height="1" width="100%"></svg:rect>
<svg:rect class="line" [attr.height]="verticalLineHeight" width="1" x="50%" transform="translate(-0.5, 0)"></svg:rect>
<svg:text class="b2 font-weight-semibold quantity" x="50%" text-anchor="middle" dominant-baseline="text-after-edge">
  {{ getQuantityText() }}
</svg:text>
